<template>
  <div class="d-block d-md-none">{{ column }}</div>
  <div class="d-block justify-content-between d-md-flex">
    <div>
      <div v-if="item.value" class="d-flex flex-column">
        <span class="fw-bold d-flex align-items-center">
          <a v-tooltip="{ title: $t('download_file') }" :href="getDownloadSrc(item.value)" target="_blank" class="link">
            <span class="link__icon">
              <FontAwesomeIcon v-if="item.icon" :icon="'fa-light fa-' + item.icon" />
            </span>
            <span class="link__text">{{ item.text ?? "" }}</span></a
          >
        </span>
      </div>
      <div v-else class="dataTable__empty">{{ $t("registration.empty_document") }}</div>
    </div>
  </div>
</template>

<script>
import { fileManager } from "@/services/file/file-manager";

export default {
  name: "DocumentCellDataTableComponent",
  components: {},
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: String,
      required: false,
      default: null,
    },
  },
  methods: {
    getDownloadSrc(file) {
      return fileManager.getDownloadSrc(file);
    },
  },
};
</script>

<style lang="scss" scoped>
.link {
  display: flex;
  &__icon {
    margin-top: 3px;
    display: flex;
    justify-content: start;
    min-width: 25px;
    max-width: 25px;
  }

  &__text {
    text-decoration: underline;
  }
}
</style>
